export const umat = {
   uid: "",
   nama: "",
   keuskupan: "",
   paroki: "",
   lingkungan_stasi: "",
   agama: "",
   nik: "",
   jk: "",
   gol_darah: "",
   email: "",
   nohp: "",
   status_kawin: "",
   tempat_lahir: "",
   tgl_lahir: "",
   suku: "",
   pendidikan: "",
   jurusan: "",
   pekerjaan: "",
   aktivitas: "",
   profesi: [],
   keterampilan: [],
   cacat_tubuh: "",
   kabupaten: "",
   kecamatan: "",
   desa: "",
   alamat: "",
   ayah: "",
   ibu: "",
   peran_masyarakat: [],
   peran_lingkungan: [],
   peran_gereja: [],
};

export const baptis = {
   id: "",
   uid: "",
   no_buku: "",
   no_lb: "",
   nama_baptis: "",
   tanggal: "",
   kriteria: "",
   keuskupan_lb: "",
   paroki_lb: "",
   wali: "",
   wali2: "",
   pembaptis: "",
};

export const komuni = {
   id: "",
   uid: "",
   no_buku_lsc: "",
   no_lsc: "",
   tgl_komuni: "",
   keuskupan_lsc: "",
   paroki_lsc: "",
   pastor: "",
};

export const krisma = {
   id: "",
   uid: "",
   tgl_krisma: "",
   no_buku_lc: "",
   no_lc: "",
   pemberi_krisma: "",
   keuskupan_lc: "",
   paroki_lc: "",
   wali1: "",
   wali2: "",
};

export const perkawinan = {
   id: "",
   uid: "",
   uid_suami: "",
   uid_istri: "",
   tgl_perkawinan: "",
   no_buku_lm: "",
   no_lm: "",
   wali: "",
   wali2: "",
   imam_peneguh: "",
   keuskupan_lm: "",
   paroki_lm: "",
   izin: "",
   no_sipil: "",
   tgl_sipil: "",
   jenis: "",
   gereja: "",
};

export const kematian = {
   id: "",
   uid: "",
   tgl_meninggal: "",
   tempat_meninggal: "",
};

export const kk = {
   id: "",
   uid: "",
   nomor: "",
   paroki: "",
   lingkungan_stasi: "",
   kabupaten: "",
   kecamatan: "",
   desa: "",
   alamat: "",
   kepala_keluarga: "",
   no_hp: "",
   no_lm: "",
   izin: "",
   no_sipil: "",
   tgl_sipil: "",
   jenis: "",
   gereja: "",
   anggota: [],
};

export const anggota = {
   id: "",
   kk_uid: "",
};

export default {
   umat,
   baptis,
   komuni,
   krisma,
   perkawinan,
   kk,
   anggota,
};
